import { Layers, Cog, DoorClosed, Check } from "lucide-react";
import { Reveal } from "../motion";
import { Eyebrow, GhostButton } from "../CTA";
import { PRODUCTS } from "../../lib/site";

const icons = { Layers, Cog, DoorClosed };

const CategoryCard = ({ cat, i, preview }) => {
  const Icon = icons[cat.icon] || Layers;
  const items = preview ? cat.items.slice(0, 6) : cat.items;
  return (
    <Reveal delay={i * 0.08}>
      <div
        className="group relative h-full overflow-hidden rounded-3xl border border-navy/10 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-brand/30 hover:shadow-[0_20px_50px_rgba(10,17,40,0.08)]"
        data-testid={`product-category-${i}`}
      >
        <div className="flex items-center gap-4">
          <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-navy text-white transition-colors duration-300 group-hover:bg-brand">
            <Icon className="h-6 w-6" />
          </span>
          <div>
            <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-steel">Category {String(i + 1).padStart(2, "0")}</div>
            <h3 className="font-display text-xl font-semibold text-navy">{cat.category}</h3>
          </div>
        </div>
        <ul className="mt-7 space-y-3">
          {items.map((item) => (
            <li key={item} className="flex items-center gap-3 text-sm text-slate-600">
              <Check className="h-4 w-4 shrink-0 text-brand" />
              {item}
            </li>
          ))}
          {preview && cat.items.length > 6 && (
            <li className="pt-1 text-sm font-semibold text-brand">+ {cat.items.length - 6} more</li>
          )}
        </ul>
      </div>
    </Reveal>
  );
};

const ProductsShowcase = ({ preview = false }) => {
  return (
    <section className="relative bg-surface py-24 sm:py-32" data-testid="products-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <Eyebrow>What We Manufacture</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
              A wide range of
              <br />
              <span className="text-steel">precision products.</span>
            </h2>
          </div>
          {preview && <GhostButton to="/products" testId="products-viewall-btn">View All Products</GhostButton>}
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {PRODUCTS.map((cat, i) => (
            <CategoryCard key={cat.category} cat={cat} i={i} preview={preview} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsShowcase;
